export default "__VITE_ASSET__e3hrEjNl__"